// Import from shared GSAP module for better code splitting
import { gsap } from '../gsap-config.js';

class LoopingWords extends HTMLElement {
    constructor() {
        super();
        this.currentIndex = 0;
    }

    connectedCallback() {
        this.initialize();
    }

    initialize() {
        this.wordList = this.querySelector('[data-looping-words-list]');
        this.words = Array.from(this.wordList.children);
        this.totalWords = this.words.length;
        this.wordHeight = 100 / this.totalWords;
        this.edgeElement = this.querySelector('[data-looping-words-selector]');

        this.initializeAnimation();
    }

    updateEdgeWidth() {
        const centerIndex = (this.currentIndex + 1) % this.totalWords;
        const centerWord = this.words[centerIndex];
        const centerWordWidth = centerWord.getBoundingClientRect().width;
        const listWidth = this.wordList.getBoundingClientRect().width;
        const percentageWidth = (centerWordWidth / listWidth) * 100;
        gsap.to(this.edgeElement, {
            width: `${percentageWidth}%`,
            duration: 0.5,
            ease: 'Expo.easeOut',
        });
        this.updateWordOpacity();
    }

    updateWordOpacity() {
        const centerIndex = (this.currentIndex + 1) % this.totalWords;
        this.words.forEach((word, index) => {
            if (index === centerIndex) {
                word.classList.add('is-active');
            } else {
                word.classList.remove('is-active');
            }
        });
    }

    moveWords() {
        this.currentIndex++;
        gsap.to(this.wordList, {
            yPercent: -this.wordHeight * this.currentIndex,
            duration: 1.2,
            ease: 'elastic.out(1, 0.85)',
            onStart: () => this.updateEdgeWidth(),
            onComplete: () => {
                if (this.currentIndex >= this.totalWords - 3) {
                    this.wordList.appendChild(this.wordList.children[0]);
                    this.currentIndex--;
                    gsap.set(this.wordList, { yPercent: -this.wordHeight * this.currentIndex });
                    this.words.push(this.words.shift());
                }
                this.updateWordOpacity();
            }
        });
    }

    initializeAnimation() {
        this.updateEdgeWidth();
        this.updateWordOpacity();
        gsap.timeline({ repeat: -1, delay: 1 })
            .call(() => this.moveWords())
            .to({}, { duration: 2 })
            .repeat(-1);
    }
}

customElements.define('looping-words', LoopingWords);